import React from 'react';
import { QrCode } from 'react-qrcode-pretty';

import { Container } from './styles';

type PixCodeParams = {
  value: string;
  size: number;
};

const PixCode: React.FC<PixCodeParams> = ({ value, size }) => {
  return (
    <Container>
      <QrCode value={value} size={size} />
    </Container>
  );
};

export default PixCode;
